

const defineCategories = () => {

    return {
        type: "DEFINE_CAT",
        data: [
        {
            value: 9,
            category: 'General Knowledge'
        },
        {
            value: 11,
            category: 'Movies'
        },
        {
            value: 12,
            category: 'Music'
        },
        {
            value: 14,
            category: 'Television'
        },
        {
            value: 17,
            category: 'Science and Nature'
        },
        {
            value: 20,
            category: 'Mythology'
        },
        {
            value: 21,
            category: 'Sports'
        },
        {
            value: 22,
            category: 'Geography'
        },
        {
            value: 23,
            category: 'History'
        },
        {
            value: 24,
            category: 'Politics'
        }
    ]}
}


export default defineCategories


